import isAfter from 'date-fns/isAfter';
import isBefore from 'date-fns/isBefore';
import isSameDay from 'date-fns/isSameDay';
import startOfDay from 'date-fns/startOfDay';
import endOfDay from 'date-fns/endOfDay';
import { DateRange } from './date-range.interface';

export const isDayWithinRange = (day: Date, start: Date | null, end: Date | null): boolean => {
  const hasBothBounds = Boolean(start && end);
  const isWithin = hasBothBounds && isAfter(day, start as Date) && isBefore(day, end as Date);

  return isWithin;
};

export const isSameCalendarDay = (day: Date, boundary: Date | null): boolean => {
  const isSame = Boolean(boundary) && isSameDay(day, boundary as Date);

  return isSame;
};

export const buildRangeFromSelectedDay = (currentRange: DateRange, selectedDay: Date): DateRange => {
  const { start, end } = currentRange;
  const hasCompleteRange = Boolean(start && end);
  const shouldRestartRange = !start || hasCompleteRange || isBefore(selectedDay, start);

  let nextRange: DateRange = { start, end: endOfDay(selectedDay) };

  if (shouldRestartRange) {
    nextRange = { start: startOfDay(selectedDay), end: null };
  }

  return nextRange;
};
